export enum ApplicationOpenType {
    SAME_TAB = 0,
    NEW_TAB = 1
}

export const APPLICATION_OPEN_TYPES = [
    ApplicationOpenType.SAME_TAB,
    ApplicationOpenType.NEW_TAB
];